import type { SimulatedParticipant } from "../game-engine/types";

export const hostParticipant: SimulatedParticipant = {
  id: "partycast-host",
  name: "Du (värd)",
  initials: "DU",
  tone: "blue",
};

export const simulatedParticipants: readonly SimulatedParticipant[] = [
  { id: "nova", name: "Nova", initials: "NO", tone: "coral" },
  { id: "leo", name: "Leo", initials: "LE", tone: "blue" },
  { id: "samira", name: "Samira", initials: "SA", tone: "mint" },
  { id: "oskar", name: "Oskar", initials: "OS", tone: "amber" },
  { id: "mei", name: "Mei", initials: "ME", tone: "violet" },
  { id: "alex", name: "Alex", initials: "AL", tone: "rose" }
];
